type Mapping = { [key: string]: string };

const CstaLevelMapping: Mapping = {
  '1A': '1A%20(Grades%20K-2%20%2F%20Ages%205-8)',
  '1B': '1B%20(Grades%203-5%20%2F%20Ages%208-11)',
  '2': '2%20(Grades%206-8%20%2F%20Ages%2011-14)',
  '3A': '3A%20(Grades%209-10%20%2F%20Ages%2014-16)',
  '3B': '3B%20(Grades%2011-12%20%2F%20Ages%2016-18)',
};

const CstaConceptMapping: Mapping = {
  AP: 'Algorithms%20%26%20Programming',
  CS: 'Computing%20Systems',
  DA: 'Data%20%26%20Analysis',
  IC: 'Impacts%20of%20Computing',
  NI: 'Networks%20%26%20the%20Internet',
};

/**
 * Generates a link to the CSTA standards webpage. Returns null if either the level or concept is
 * invalid.
 * @param level
 * @param concept
 */
export function getCstaLink(level: string, concept: string): string | null {
  const levelKey = CstaLevelMapping[level];
  const conceptKey = CstaConceptMapping[concept];

  if (!(levelKey && conceptKey)) {
    return null;
  }

  return `https://awesome-table.com/-KhwxL5L_YDYdtn1rtBR/view?filterE=${CstaLevelMapping[level]}&filterI=${CstaConceptMapping[concept]}`;
}
